import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { isGeneratedFile } from '@angular/compiler/src/aot/util';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { Anagrafica, Company } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';


export interface Response_Login_Service {
  data: Response_Login | UserInfo | undefined,
  error?: any,
  msg: string,
  success: boolean
}

export interface Response_Login {
  access_token: string
  change_password: boolean
  email: string
  limite_fatture: number
  user_id: string
}

export interface UserInfo {
  abilita_ftp: number
  abilita_mail: number
  abilita_mail_ordini: number
  abilita_nso: number
  abilita_peppol: number
  abilita_ddt: number 
  abilitato: number
  cfpiva?: string
  codice_fiscale?: string
  codice_ipa?: string
  codice_univoco: string
  denominazione?: string
  dms_api_url: string
  dms_company: Company
  dms_company_id: string
  dms_df_type_id: string | null
  dms_dfli_workflow_id: string | null
  dms_einvoice_type_id: string
  dms_einvoice_workflow2_id: string
  dms_einvoice_workflow_id: string
  dms_einvoice_workflowp_id: string
  dms_einvoicep_type_id: string
  dms_fattura_ubl_attiva_id: string
  dms_fattura_ubl_passiva_id: string
  dms_li_type_id: string | null
  dms_ordini_inviati_id: string
  dms_ordini_ricevuti_id: string
  dms_ddt_attiva_id: string
  dms_ddt_passiva_id: string
  dms_password: string
  dms_user_id: string
  dms_username: string
  domain_name?: string
  email: string
  email_passiva: string
  email_pec: string
  email_ricezione_ordini: string
  environment_id: string
  firma_password: string
  firma_username: string
  id: number | string
  id_utente?: number
  id_utente_admin: string
  id_utente_reseller: string
  json_data?: string
  json_sdi_data: string
  limite_fatture: number
  limite_ordini: number
  limite_ddt: number
  limite_utenti_gestiti: number
  mod_ric_fp: string
  partita_iva: string
  password?: string | null
  password_pec?: string
  proprio_indirizzo?: string
  role: string
  rolename?: string
  sdi_data?: Anagrafica
  tipo?: string
  username: string
  sola_lettura?: number,
  fatturazione: string,
  consulenza: string,
  timbratura: string,
  user_id: string
}

export interface UserData {
  user_id: string
  username: string
  mail: string
  ruolo: number
  primo_accesso: boolean
  pkg_fatture: number
  fatture_rimanenti: number
  abilitato: number,
  denominazione: string,
  partita_iva: string,
  codice_fiscale: string,
  id_utente_admin: number,
  id_utente_reseller: number,
  mail_passiva: string,
  mail_notifiche: string,
  json_sdi_data: string
}

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  private e_invoiceUrl : string =  environment.url;
  //private e_invoiceUrl: string = AppConfig.settings.apiServer.url;

  private _userInfo: UserInfo | undefined;
  private _sessionUserInfo: any;

  constructor(private http: HttpClient, private router: Router) {
    /*let key = localStorage.getItem('access_token_einvoice');
    if (key) {
      this.checkLogin();
    } else {
      //this.router.navigate(['../Login']);
    }*/
  }

  resetUserInfo() {
    this._userInfo = undefined;
  }

  async getUserInfo(): Promise<UserInfo | undefined> {
    //if (!this._userInfo)
      //this._userInfo = await this.loadInfoUserDelayed();
    this._userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
    return this._userInfo;
  }

  async loadInfoUserDelayed() {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/me/")
      .toPromise()
      .then((data: any) => {
        let response = data as Response_Login_Service;
        if (response.success) {
          this.loadUserDenominazoneCfPiva(response.data as UserInfo);
          return response.data as UserInfo;
        }
        return undefined;
      })
      .catch(() => {
        return undefined;
      });
  }


  /********originale **********
  private async getUserInfo(): Promise<UserInfo | undefined>{
    if(!this._userInfo){
      await this.loadInfoUser();
    }
    return this._userInfo;
  }
  **/

  async getSessionUserInfo(): Promise<any> {
    if (!this._sessionUserInfo) {
      this._sessionUserInfo = await this.getUserInfo();
    }
    if (this._sessionUserInfo != undefined)
      this.loadUserDenominazoneCfPiva(this._sessionUserInfo);
    return this._sessionUserInfo;
  }

  setSessionUserInfo(sessionUser: any) {
    this._sessionUserInfo = sessionUser;
  }

  async first_access_password(userId: string, body: any) {
    let response = await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + userId + "/first_access_password/", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        this.router.navigate(['../Login']);
      });
    return response;
  }

  async auth_recovery(body: any) {
    let response = await this.http.post(this.e_invoiceUrl + "/api/v1/auth/recover/", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        this.router.navigate(['../Login']);
      });
    return response;
  }

  async setToken(body: any) {
    let response = await this.http.post(this.e_invoiceUrl + "/api/v1/auth/set_token/", { access_token: body })
      .toPromise()
      .then((data: any) => {
        localStorage.setItem('access_token_einvoice', body);
        return data;
      }).catch(() => {
        this.router.navigate(['../Login']);
      });
    return response;
  }

  async refreshUserInfo(): Promise<UserInfo | undefined> {
    await this.loadInfoUser();
    return this._userInfo;
  }

  async getVersion() {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/version")
      .toPromise()
      .then((data: any) => {
        return data
      })
      .catch(() => {
        let log: Response_Login_Service = {
          success: false,
          msg: 'ERRORE LOGIN',
          data: undefined
        };
        return log;
      });
  }


  async checkLogin() {
    let check: boolean = await this.http.get(this.e_invoiceUrl + "/api/v1/users/me/")
      .toPromise()
      .then((data: any) => {
        return data.success;
      })
      .catch(() => {
        return false;
      });
    // console.log(check);
    if (!check) {
      this.router.navigate(['Login']);
    }
  }


  hasRoles(roles: string[]) {
    return roles.filter(v => v == this._userInfo!.role).length > 0;
  }

  /**
   * Effettua la chiamata relativa al login
   * @param username 
   * @param password 
   * @returns booleano se il login è andato a buon fine
   */
  async doPostLogin(username: string, password: string): Promise<Response_Login_Service> {
    return await this.http.post(this.e_invoiceUrl + "/api/v1/auth/", { username: username, password: password })
      .toPromise()
      .then((data: any) => {
        return data
      })
      .catch(() => {
        let log: Response_Login_Service = {
          success: false,
          msg: 'ERRORE LOGIN',
          data: undefined
        };
        return log;
      });

  }

  /**
   * Recupera le info di un utente
   */
  async loadInfoUser() {
    let response = await this.http.get(this.e_invoiceUrl + "/api/v1/users/me/")
      .toPromise()
      .then((data: any) => {
        return data as Response_Login_Service
      })
      .catch(() => {
        let log: Response_Login_Service = {
          success: false,
          msg: 'ERRORE LOGIN',
          data: undefined
        };
        return log;
      });
    if (response.success) {
      this._userInfo = response.data as UserInfo;
      //estraggo denominazione, e cfpiva se non esistono.
      this.loadUserDenominazoneCfPiva(this._userInfo);
    }
  }

  loadUserDenominazoneCfPiva(user: UserInfo) {
    try {
      let jsData = JSON.parse(user.json_sdi_data);
      if (user.denominazione == undefined)
        user.denominazione = jsData.DatiAnagrafici.Anagrafica.Denominazione;
      if (user.cfpiva == undefined)
        user.cfpiva = jsData.DatiAnagrafici.IdFiscaleIVA.IdPaese + '' + jsData.DatiAnagrafici.IdFiscaleIVA.IdCodice;
    } catch (e) {
    }
  }


  async logout() {
    let response = await this.http.delete(this.e_invoiceUrl + "/api/v1/auth/")
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        this.router.navigate(['../Login']);
      });
    return response;
  }
}


